<template>
  <div id="companyProfile"> 
    <Navigation/>
    <div class="container-fluid container_fluid">
      <div class="row fluid_row">
        <!-- <div > -->
        <div class="col-md-3 left_Column" v-if="screenWidth > 750"> 
          <div class="col-md-6 left_cont" v-for="(target,id) in leftList" :key="id" @click="choseprofrom(id)" >
            <a :href="'#'+target.ul" :class="{'secectBackground':flag==id}">{{target.name}}</a>
          </div>
        </div>
        <!-- </div> -->

        <div class="col-md-8 right_Content">
          <!-- 公司简介 -->
          <div class="col-md-12 right_Modular" >
            <p id="one"></p><br/>
            <div class="col-md-12">
              <div class="right_border"></div>
              <div class="right_cont_title">公司简介</div>
              <div class="right_cont_slogan">让中医药健康服务，插上智能化翅膀</div>
            </div>
            <div class="col-md-12 right_cont_content">
              <p class="right_cont_p">上海岐素信息科技有限公司从事计算机科技领域内的技术开发、文化艺术交流策划及电子商务领域，致力于中医药健康产业整合，传播中医药优秀文化、推广健康生活方式、提升大众的自我保健能力。</p>
            </div>
            <div class="col-md-9 right_cont_image" >
              <img :src="CompanyTop" class="cont_image">
            </div>
          </div>
          <!-- 公司理念 -->
          <!-- <div class="col-md-12" name="two"></div> -->
          <div class="col-md-12 right_Modular" >
            <p id="two"></p><br/>
            <div class="col-md-12">
              <div class="right_border"></div>
              <div class="col-md-12 right_cont_title">公司理念</div>
              <div class="col-md-12 right_cont_slogan">展现公司魅力，彰显公司文化</div>
            </div>
            
            <div class="col-md-9 right_cont_image">
              <img :src="CompanyIdea" class="cont_imageIdea">
            </div>
          </div>

        </div>
      </div>

    </div>
    <ReturnTop/>
    <HeadTail/>
  </div>
</template>

<script>
import navigation from './publicComponent/Navigation'
import headTail from './publicComponent/HeadTail'
import returnTop from './publicComponent/ReturnTop'
export default {
  data(){
    return{
      leftList:[
        {name:"公司简介",id:1,ul:"one"},
        {name:"公司理念",id:2,ul:"two"},
      ],
      flag: -1,
      screenWidth: document.body.clientWidth,
    }
  },
  created(){
    this.flag = 0
    if(document.body.clientWidth > 750){
      this.CompanyTop = '../../static/image/CompanyProfileImage/contentImage.png'
      this.CompanyIdea = '../../static/image/CompanyProfileImage/Good_LeJing_move.png'
    }else{
      this.CompanyTop = ''
      this.CompanyIdea = '../../static/image/CompanyProfileImage/Good_LeJing_moves.png'
    }
  },
  methods:{
      choseprofrom:function (id) {
        this.flag = id;
      }
  },
  components: {
    'HeadTail': headTail,  //将别名demo 变成 组件 Demo
    "Navigation":navigation,
    "ReturnTop" : returnTop 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width: 750px){
    .fluid_row{
      margin-top: 11vh !important;
    }
    /* 左侧 */
    .left_Column{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-left: 6% !important;
    }
    .left_cont{
      text-align: right;
      height: 2vw !important;
      line-height: 2vw;
      border-top: 1px solid #f1f1f1; 
      border-bottom: 1px solid #f1f1f1; 
    }
    .secectBackground{
      border-right: 2px solid #0047ab;
      color: #0047ab !important;
    }
    /* 右侧 */
    /* 模块 */
    .right_Modular{
        margin-bottom: 15% !important;
    }
    .right_border{
      width: 12vw;
      height: 8vw;
      position: absolute;
      border: 10px solid #ebeced;
      left: 6%;
      top: 18%;
      z-index: -1;
    }
    .right_cont_title{
      font-size: 3vw;
      color: #0047ab;
      padding-left: 2% !important;
      padding-top: 3% !important;
      font-weight: 600;
      cursor:pointer;
    }
    .right_cont_slogan{
      font-size: 1.5vw;
      font-weight: 600;
      padding-left: 2% !important;
    }
    .right_cont_content{
      font-size: 0.9vw;
      padding-left: 2% !important;
      padding-top: 3% !important;
    }
    .right_cont_p{
          padding-right: 37% !important;
    }
    .cont_image{
      width: 100%;
    }
    .cont_imageIdea{
      padding-left: 2% !important;
      padding-top: 5% !important;
      width: 100%;
    }
    .left_cont>a{
      display: block;
      color: #000;
      padding-right: 20% !important;
      font-size: 13pt;
    }

}

/* 移动端特殊样式 */
@media screen and (max-width: 750px){
    
    .container-fluid{
      margin-top: 12% !important;
    }
    .cont_image{
      width: 100%;
    }
    .cont_imageIdea{
      width: 100%;
    }

    .right_Modular{
        margin-bottom: 15% !important;
    }
    .right_border{
      width: 29vw;
      height: 18vw;
      position: absolute;
      border: 6px solid #ebeced;
      left: 13%;
      top: 6%;
      z-index: -1;
    }
    .right_cont_title{
      font-size: 6vw;
      color: #0047ab;
      padding-left: 2% !important;
      padding-top: 3% !important;
      font-weight: 600;
    }
    .right_cont_slogan{
      font-size: 4vw;
      font-weight: 600;
      padding-left: 2% !important;
    }
    .right_cont_content{
      font-size: 0.9vw;
      padding-left: 2% !important;
      padding-top: 3% !important;
      padding-right: 2% !important;
    }
    .right_cont_p{
      font-size: 11pt;
      padding-top: 2vh !important;
      text-align: justify;
    }
    .cont_imageIdea{
      padding-left: 2% !important;
      padding-top: 5% !important;
      padding-right: 2% !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/CompanyProfile.vue